import dollarIcon from '@/assets/icons/dollar-sign-round-green.svg';

export default {
  props: {
    level: {
      type: String,
      default: 'success',
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    iconSrc() {
      if (this.icon === 'dollar') {
        return dollarIcon;
      }
      return null;
    },
    levelModifier() {
      return `alert-box--${this.level}`;
    },
  },
};
